var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"!text-red-500",attrs:{"aria-label":"Campo obligatorio"}},[_vm._v(" * ")])}
var staticRenderFns = []

export { render, staticRenderFns }